import { Injectable } from '@angular/core';
import { Converter, EntitiesModel, ConverterService } from '@spartacus/core';
import { UIG_BRANCH_NORMALIZER } from '../store/uig-branches.adapter';
import { Branch, BranchesList } from '../uig-branches/uig-branches.models';

@Injectable({
  providedIn: 'root',
})
export class UigBranchesListNormalizer
  implements Converter<BranchesList, EntitiesModel<Branch>> {
  constructor(private converter: ConverterService) { }

  convert(
    source: BranchesList,
    target?: EntitiesModel<Branch>
  ): EntitiesModel<Branch> {
    if (target === undefined) {
      target = { ...(source as any) };
    }
    target.values = source.branches.map((branch) => ({
      ...this.converter.convert(branch, UIG_BRANCH_NORMALIZER),
    }));

    return target;
  }
}